/* tslint:disable */
/* eslint-disable */
/**
 * CourierApi
 * CourierApi
 *
 * The version of the OpenAPI document: 2.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface InvoiceGenerateInvoiceForDeliveryRequestRequest
 */
export interface InvoiceGenerateInvoiceForDeliveryRequestRequest {
    /**
     * 
     * @type {number}
     * @memberof InvoiceGenerateInvoiceForDeliveryRequestRequest
     */
    deliveryRequestId: number;
}

/**
 * Check if a given object implements the InvoiceGenerateInvoiceForDeliveryRequestRequest interface.
 */
export function instanceOfInvoiceGenerateInvoiceForDeliveryRequestRequest(value: object): value is InvoiceGenerateInvoiceForDeliveryRequestRequest {
    if (!('deliveryRequestId' in value) || value['deliveryRequestId'] === undefined) return false;
    return true;
}

export function InvoiceGenerateInvoiceForDeliveryRequestRequestFromJSON(json: any): InvoiceGenerateInvoiceForDeliveryRequestRequest {
    return InvoiceGenerateInvoiceForDeliveryRequestRequestFromJSONTyped(json, false);
}

export function InvoiceGenerateInvoiceForDeliveryRequestRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): InvoiceGenerateInvoiceForDeliveryRequestRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'deliveryRequestId': json['deliveryRequestId'],
    };
}

export function InvoiceGenerateInvoiceForDeliveryRequestRequestToJSON(json: any): InvoiceGenerateInvoiceForDeliveryRequestRequest {
    return InvoiceGenerateInvoiceForDeliveryRequestRequestToJSONTyped(json, false);
}

export function InvoiceGenerateInvoiceForDeliveryRequestRequestToJSONTyped(value?: InvoiceGenerateInvoiceForDeliveryRequestRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'deliveryRequestId': value['deliveryRequestId'],
    };
}

